/*
 * ================================================================
 * RÉFÉRENTIEL PAYS / DEVISES — REPLI D'AFFICHAGE
 * ================================================================
 *
 * La source de vérité pays → devise est le backend
 * assiganto-commercial-financial-platform (GET /countries), chargé au
 * démarrage dans le slice country (setCurrencyReferential) : il prime.
 * Cette table ne sert qu'en attendant sa réponse (ou hors ligne). Elle
 * ne contient aucun pays facturé en EUR.
 *
 * La devise d'une transaction (accord, offre, paiement, produit) reste
 * celle renvoyée par le backend : ce référentiel ne fournit que la devise
 * de contexte (pays d'activité) et les repli d'affichage.
 * ================================================================
 */

export const CURRENCIES = {
    XOF: { code: "XOF", label: "Franc CFA (BCEAO)", symbol: "FCFA", fractionDigits: 0 },
    XAF: { code: "XAF", label: "Franc CFA (BEAC)", symbol: "FCFA", fractionDigits: 0 },
    NGN: { code: "NGN", label: "Naira", symbol: "₦", fractionDigits: 2 },
    GHS: { code: "GHS", label: "Cedi", symbol: "GH₵", fractionDigits: 2 },
    EUR: { code: "EUR", label: "Euro", symbol: "€", fractionDigits: 2 }
};

/** Devise utilisée tant que le pays d'activité n'est pas résolu. */
export const DEFAULT_CURRENCY = "XOF";

/** Pays déployés, indexés par code ISO 3166-1 alpha-2. */
export const COUNTRIES = {
    TG: { label: "Togo", currency: "XOF" },
    BJ: { label: "Bénin", currency: "XOF" },
    NE: { label: "Niger", currency: "XOF" },
    CI: { label: "Côte d'Ivoire", currency: "XOF" },
    ML: { label: "Mali", currency: "XOF" },
    BF: { label: "Burkina Faso", currency: "XOF" },
    SN: { label: "Sénégal", currency: "XOF" },
    CM: { label: "Cameroun", currency: "XAF" },
    NG: { label: "Nigeria", currency: "NGN" },
    GH: { label: "Ghana", currency: "GHS" }
};

const normalizeCode = code => (typeof code === "string" ? code.toUpperCase() : null);

export const isSupportedCountryCode = code => Boolean(COUNTRIES[normalizeCode(code)]);

/** Devise d'un pays déployé, DEFAULT_CURRENCY sinon. */
export const getCountryCurrency = code =>
    COUNTRIES[normalizeCode(code)]?.currency ?? DEFAULT_CURRENCY;

/** Symbole d'affichage (« FCFA », « ₦ »…), le code ISO pour une devise inconnue. */
export const getCurrencySymbol = currency =>
    CURRENCIES[currency]?.symbol ?? currency ?? CURRENCIES[DEFAULT_CURRENCY].symbol;

export const getCurrencyFractionDigits = currency =>
    CURRENCIES[currency]?.fractionDigits ?? 2;
